import { render, staticRenderFns } from "./DigitalResultGazette.vue?vue&type=template&id=73cd7c56&scoped=true"
import script from "./DigitalResultGazette.vue?vue&type=script&lang=js"
export * from "./DigitalResultGazette.vue?vue&type=script&lang=js"
import style0 from "./DigitalResultGazette.vue?vue&type=style&index=0&id=73cd7c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd7c56",
  null
  
)

export default component.exports